const ACTIONS = {
  ARROW_NEXT: 'next',
  ARROW_PREV: 'previous',
};

export default ACTIONS;
